module.exports = __webpack_public_path__ + "img/sec2_5_.84a7c2a4.png";